<template>
	<!-- Vue Material Tabs -->
	<!-- https://vuematerial.io/components/tabs -->
	<md-tabs
		:md-alignment="align"
		class="ui-tabs"
	>
		<slot/>
	</md-tabs>
</template>

<script>
export default {
	name: "Tabs",
	props: {
		align: {
			type: String,
			default: "fixed", // left, right, centered, fixed
			required: false
		}
	}
};
</script>

<style scoped>
/* this styling will only apply to IE11 */
@media all and (-ms-high-contrast:none) {
	*::-ms-backdrop, .ui-tabs {
		flex-basis: auto; /* fixes IE11 issue with tabs not being calculated as part of dialog height */
	}
}
</style>
